import { Component, OnInit } from '@angular/core';
import { filter, switchMap } from 'rxjs/operators';
import { Client } from 'src/app/domain/models';
import { ClientService } from 'src/app/domain/services/client.service';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { Application, ProviderContact } from '../../models';
import { ApplicationService } from '../../services';
import { CurrentApplicationService } from '../../services/current-application.service';

@Component({
    selector: 'app-application-confirmation',
    templateUrl: './application-confirmation.component.html',
    styleUrls: ['./application-confirmation.component.scss'],
    standalone: false
})
export class ApplicationConfirmationComponent implements OnInit {
    providerContacts: ProviderContact[] | undefined;
    client: Client | undefined;

    constructor(
        private readonly applicationService: ApplicationService,
        private readonly currentAppService: CurrentApplicationService,
        private readonly _client: ClientService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.currentAppService.load();
    }

    ngOnInit() {
        this._googleAnalyticsService.pageView('Application: Complete');
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
        this.currentAppService.latest
            .pipe(
                filter(
                    (application) =>
                        application !== null &&
                        application !== undefined &&
                        application.applicationId != undefined
                ),
                switchMap((application: Application | undefined) =>
                    this.applicationService.getSelectedProviderContacts(
                        application!.applicationId!
                    )
                )
            )
            .subscribe((result) => {
                this.providerContacts = result;
            });
    }
}
